<template>
  <div class="pt-600">
    <BContainer full>
      <BCard
        v-loading="loading"
        shadow
      >
        <BLayout
          class="mb-200"
          justify-space-between
          align-center
        >
          <h2>{{ $t('defaultPromptSetting.title') }}</h2>
        </BLayout>

        <BListItem class="mb-300">
          <template #header>
            <span>{{ $t('defaultPromptSetting.basePrompt') }}</span>
          </template>
          <BTextarea
            v-if="baseSetting"
            v-model="baseSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.defaultPrompt') }}</span>
          </template>
          <BTextarea
            v-if="defaultSetting"
            v-model="defaultSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.transcriptionSummaryPromptTemplate') }}</span>
          </template>
          <div class="useable-placeholders-container">
            <div>{{ $t('defaultPromptSetting.useablePlaceholders') }}</div>
            <div class="useable-placeholders">
              <div
                v-for="placeholder in transcriptionSummaryPromptTemplatePlaceholders"
                :key="placeholder"
                class="useable-placeholders-item"
              >
                <div>{{ placeholder }}</div>
                <BCopyButton
                  :text="placeholder"
                  :title="placeholder"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="transcriptionSummaryTemplateSetting"
            v-model="transcriptionSummaryTemplateSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <div>{{ $t('defaultPromptSetting.timelinePrompt') }}</div>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in timelinePromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="timelineSetting"
            v-model="timelineSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <div>{{ $t('defaultPromptSetting.dealAcquiredJudgmentPrompt') }}</div>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in dealAcquiredJudgmentPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="dealAcquiredJudgmentSetting"
            v-model="dealAcquiredJudgmentSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.hearingItemExtractionPromptTemplate') }}</span>
          </template>
          <div class="useable-placeholders-container">
            <div>{{ $t('defaultPromptSetting.useablePlaceholders') }}</div>
            <div class="useable-placeholders">
              <div
                v-for="placeholder in hearingItemExtractionPromptTemplatePlaceholders"
                :key="placeholder"
                class="useable-placeholders-item"
              >
                <div>{{ placeholder }}</div>
                <BCopyButton
                  :text="placeholder"
                  :title="placeholder"
                  icon-button
                />
              </div>
            </div>
          </div>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in hearingItemExtractionPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="hearingItemExtractionTemplateSetting"
            v-model="hearingItemExtractionTemplateSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.followUpNecessityJudgmentPromptTemplate') }}</span>
          </template>
          <div class="useable-placeholders-container">
            <div>{{ $t('defaultPromptSetting.useablePlaceholders') }}</div>
            <div class="useable-placeholders">
              <div
                v-for="placeholder in followUpNecessityJudgmentPromptTemplatePlaceholders"
                :key="placeholder"
                class="useable-placeholders-item"
              >
                <div>{{ placeholder }}</div>
                <BCopyButton
                  :text="placeholder"
                  :title="placeholder"
                  icon-button
                />
              </div>
            </div>
          </div>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in followUpNecessityJudgmentPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="followUpNecessityJudgmentTemplateSetting"
            v-model="followUpNecessityJudgmentTemplateSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.speakerIdentificationPrompt') }}</span>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in speakerIdentificationPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="speakerIdentificationSetting"
            v-model="speakerIdentificationSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.qualitativeFeedbackPrompt') }}</span>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in qualitativeFeedbackPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="qualitativeFeedbackSetting"
            v-model="qualitativeFeedbackSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <div>{{ $t('defaultPromptSetting.voicemailJudgmentPrompt') }}</div>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in voicemailJudgmentPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="voicemailJudgmentSetting"
            v-model="voicemailJudgmentSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.aiFeedbackConnectedPrompt') }}</span>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in aiFeedbackConnectedPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="aiFeedbackConnectedSetting"
            v-model="aiFeedbackConnectedSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.aiFeedbackUnconnectedPrompt') }}</span>
          </template>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in aiFeedbackUnconnectedPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="aiFeedbackUnconnectedSetting"
            v-model="aiFeedbackUnconnectedSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.nextActionSuggestionExtractionPrompt') }}</span>
          </template>
          <div class="useable-placeholders-container">
            <div>{{ $t('defaultPromptSetting.useablePlaceholders') }}</div>
            <div class="useable-placeholders">
              <div
                v-for="placeholder in nextActionSuggestionExtractionPromptTemplatePlaceholders"
                :key="placeholder"
                class="useable-placeholders-item"
              >
                <div>{{ placeholder }}</div>
                <BCopyButton
                  :text="placeholder"
                  :title="placeholder"
                  icon-button
                />
              </div>
            </div>
          </div>
          <div class="useable-json-keys-container">
            <div>{{ `${$t('defaultPromptSetting.useableJsonKeys')}：` }}</div>
            <div class="useable-json-keys">
              <div
                v-for="jsonKey in nextActionSuggestionExtractionPromptJsonKeys"
                :key="jsonKey"
                class="useable-json-keys-item"
              >
                <div>{{ jsonKey }}</div>
                <BCopyButton
                  :text="jsonKey"
                  :title="jsonKey"
                  icon-button
                />
              </div>
            </div>
          </div>
          <BTextarea
            v-if="nextActionSuggestionExtractionSetting"
            v-model="nextActionSuggestionExtractionSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BListItem class="mb-600">
          <template #header>
            <span>{{ $t('defaultPromptSetting.transcriptionCorrectionPrompt') }}</span>
          </template>
          <BTextarea
            v-if="transcriptionCorrectionSetting"
            v-model="transcriptionCorrectionSetting.prompt"
            required
            :autosize="{ minRows: 10, maxRows: 20 }"
          />
        </BListItem>
        <BLayout justify-center>
          <BBtn
            type="primary"
            @click="handleSaveClick"
          >
            {{ $t('general.save.text') }}
          </BBtn>
        </BLayout>
      </BCard>
    </BContainer>
  </div>
</template>

<script lang="ts" setup>
import { ref, onBeforeMount, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { DefaultPromptSettingService } from '@/api/admin/resources/default_prompt_setting';
import { PromptJsonKeyService } from '@/api/admin/resources/prompt_json_key';
import { PromptTemplatePlaceholderService } from '@/api/admin/resources/prompt_template_placeholder';
import { DefaultPromptSetting } from '@/api/openapi';
import { useErrorHandler } from '@/composable/error-handler';
import { useAlert } from '@/composable/message-dialog';
import { useWait } from '@/composable/vue-wait';

const baseSetting = ref<DefaultPromptSetting>();
const defaultSetting = ref<DefaultPromptSetting>();
const transcriptionSummaryTemplateSetting = ref<DefaultPromptSetting>();
const transcriptionSummaryPromptTemplatePlaceholders = ref<string[]>([]);
const timelineSetting = ref<DefaultPromptSetting>();
const timelinePromptJsonKeys = ref<string[]>([]);
const dealAcquiredJudgmentSetting = ref<DefaultPromptSetting>();
const dealAcquiredJudgmentPromptJsonKeys = ref<string[]>([]);
const hearingItemExtractionTemplateSetting = ref<DefaultPromptSetting>();
const hearingItemExtractionPromptTemplatePlaceholders = ref<string[]>([]);
const hearingItemExtractionPromptJsonKeys = ref<string[]>([]);
const followUpNecessityJudgmentTemplateSetting = ref<DefaultPromptSetting>();
const followUpNecessityJudgmentPromptTemplatePlaceholders = ref<string[]>([]);
const followUpNecessityJudgmentPromptJsonKeys = ref<string[]>([]);
const speakerIdentificationSetting = ref<DefaultPromptSetting>();
const speakerIdentificationPromptJsonKeys = ref<string[]>([]);
const qualitativeFeedbackSetting = ref<DefaultPromptSetting>();
const qualitativeFeedbackPromptJsonKeys = ref<string[]>([]);
const voicemailJudgmentSetting = ref<DefaultPromptSetting>();
const voicemailJudgmentPromptJsonKeys = ref<string[]>([]);
const aiFeedbackConnectedSetting = ref<DefaultPromptSetting>();
const aiFeedbackConnectedPromptJsonKeys = ref<string[]>([]);
const aiFeedbackUnconnectedSetting = ref<DefaultPromptSetting>();
const aiFeedbackUnconnectedPromptJsonKeys = ref<string[]>([]);
const nextActionSuggestionExtractionSetting = ref<DefaultPromptSetting>();
const nextActionSuggestionExtractionPromptTemplatePlaceholders = ref<string[]>([]);
const nextActionSuggestionExtractionPromptJsonKeys = ref<string[]>([]);
const transcriptionCorrectionSetting = ref<DefaultPromptSetting>();

const i18n = useI18n();
const { doActionWithWait, wait } = useWait();
const { alert } = useAlert();
const { defaultHandler } = useErrorHandler();
const api = new DefaultPromptSettingService();

onBeforeMount(async () => {
  await Promise.all([
    fetchDefaultPromptSettings(),
    fetchPromptTemplatePlaceholders(),
    fetchTimelinePromptJsonKeys(),
    fetchDealAcquiredJudgmentPromptJsonKeys(),
    fetchHearingItemExtractionPromptJsonKeys(),
    fetchFollowUpNecessityJudgmentPromptJsonKeys(),
    fetchHearingItemExtractionPromptTemplatePlaceholders(),
    fetchFollowUpNecessityJudgmentPromptTemplatePlaceholders(),
    fetchSpeakerIdentificationPromptJsonKeys(),
    fetchQualitativeFeedbackPromptJsonKeys(),
    fetchVoicemailJudgmentPromptJsonKeys(),
    fetchAiFeedbackPromptJsonKeys(),
    fetchNextActionSuggestionExtractionPromptTemplatePlaceholders(),
    fetchNextActionSuggestionExtractionPromptJsonKeys(),
  ]);
});

const loading = computed(() => {
  return wait.is(['fetchDefaultPromptSettingsWait', 'savePromptSettingWait', 'fetchPromptTemplatePlaceholdersWait']);
});

const fetchDefaultPromptSettings = async () => {
  await doActionWithWait('fetchDefaultPromptSettingsWait', async () => {
    const { data: { defaultPromptSettings } } = await api.getDefaultPromptSettings();
    baseSetting.value = defaultPromptSettings.find((e) => e.promptType === 'transcription_summary_base');
    defaultSetting.value = defaultPromptSettings.find((e) => e.promptType === 'transcription_summary_default');
    transcriptionSummaryTemplateSetting.value = defaultPromptSettings.find((e) => e.promptType === 'transcription_summary_template');
    timelineSetting.value = defaultPromptSettings.find((e) => e.promptType === 'transcription_timeline_default');
    dealAcquiredJudgmentSetting.value = defaultPromptSettings.find((e) => e.promptType === 'deal_acquired_judgment_default');
    hearingItemExtractionTemplateSetting.value = defaultPromptSettings.find((e) => e.promptType === 'hearing_item_extraction_template');
    followUpNecessityJudgmentTemplateSetting.value = defaultPromptSettings.find((e) => e.promptType === 'follow_up_necessity_judgment_template');
    speakerIdentificationSetting.value = defaultPromptSettings.find((e) => e.promptType === 'speaker_identification_default');
    qualitativeFeedbackSetting.value = defaultPromptSettings.find((e) => e.promptType === 'qualitative_feedback_default');
    voicemailJudgmentSetting.value = defaultPromptSettings.find((e) => e.promptType === 'voicemail_judgment_default');
    aiFeedbackConnectedSetting.value = defaultPromptSettings.find((e) => e.promptType === 'ai_feedback_connected_default');
    aiFeedbackUnconnectedSetting.value = defaultPromptSettings.find((e) => e.promptType === 'ai_feedback_unconnected_default');
    nextActionSuggestionExtractionSetting.value = defaultPromptSettings.find((e) => e.promptType === 'next_action_suggestion_extraction_default');
    transcriptionCorrectionSetting.value = defaultPromptSettings.find((e) => e.promptType === 'transcription_correction_default');
  });
};

const fetchPromptTemplatePlaceholders = async () => {
  await doActionWithWait('fetchPromptTemplatePlaceholdersWait', async () => {
    const api = new PromptTemplatePlaceholderService();
    const { data } = await api.getTranscriptionSummaryPromptTemplatePlaceholders();
    transcriptionSummaryPromptTemplatePlaceholders.value = data;
  });
};

const fetchTimelinePromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getTimelinePromptJsonKeys();
  timelinePromptJsonKeys.value = data;
};

const fetchDealAcquiredJudgmentPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getDealAcquiredJudgmentPromptJsonKeys();
  dealAcquiredJudgmentPromptJsonKeys.value = data;
};

const fetchHearingItemExtractionPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getHearingItemExtractionPromptJsonKeys();
  hearingItemExtractionPromptJsonKeys.value = data;
};

const fetchFollowUpNecessityJudgmentPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getFollowUpNecessityJudgmentPromptJsonKeys();
  followUpNecessityJudgmentPromptJsonKeys.value = data;
};

const fetchSpeakerIdentificationPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getSpeakerIdentificationPromptJsonKeys();
  speakerIdentificationPromptJsonKeys.value = data;
};

const fetchQualitativeFeedbackPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getQualitativeFeedbackPromptJsonKeys();
  qualitativeFeedbackPromptJsonKeys.value = data;
};

const fetchAiFeedbackPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getAiFeedbackPromptJsonKeys();
  aiFeedbackConnectedPromptJsonKeys.value = data;
  aiFeedbackUnconnectedPromptJsonKeys.value = data;
};

const fetchHearingItemExtractionPromptTemplatePlaceholders = async () => {
  const api = new PromptTemplatePlaceholderService();
  const { data } = await api.getHearingItemExtractionPromptTemplatePlaceholders();
  hearingItemExtractionPromptTemplatePlaceholders.value = data;
};

const fetchFollowUpNecessityJudgmentPromptTemplatePlaceholders = async () => {
  const api = new PromptTemplatePlaceholderService();
  const { data } = await api.getFollowUpNecessityJudgmentPromptTemplatePlaceholders();
  followUpNecessityJudgmentPromptTemplatePlaceholders.value = data;
};

const fetchVoicemailJudgmentPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getVoicemailJudgmentPromptJsonKeys();
  voicemailJudgmentPromptJsonKeys.value = data;
};

const fetchNextActionSuggestionExtractionPromptTemplatePlaceholders = async () => {
  const api = new PromptTemplatePlaceholderService();
  const { data } = await api.getNextActionSuggestionExtractionPromptTemplatePlaceholders();
  nextActionSuggestionExtractionPromptTemplatePlaceholders.value = data;
};

const fetchNextActionSuggestionExtractionPromptJsonKeys = async () => {
  const api = new PromptJsonKeyService();
  const { data } = await api.getNextActionSuggestionExtractionPromptJsonKeys();
  nextActionSuggestionExtractionPromptJsonKeys.value = data;
};

const handleSaveClick = async () => {
  await doActionWithWait('savePromptSettingWait', async () => {
    await api.postDefaultPromptSettings({
      request: {
        getDefaultPromptSettings200Response: {
          defaultPromptSettings: [
            baseSetting.value,
            defaultSetting.value,
            transcriptionSummaryTemplateSetting.value,
            timelineSetting.value,
            dealAcquiredJudgmentSetting.value,
            hearingItemExtractionTemplateSetting.value,
            followUpNecessityJudgmentTemplateSetting.value,
            speakerIdentificationSetting.value,
            qualitativeFeedbackSetting.value,
            voicemailJudgmentSetting.value,
            aiFeedbackConnectedSetting.value,
            aiFeedbackUnconnectedSetting.value,
            nextActionSuggestionExtractionSetting.value,
            transcriptionCorrectionSetting.value,
          ],
        },
      },
      errorHandlers: {
        500: defaultHandler,
      },
    });
    await alert({
      title: i18n.t('defaultPromptSetting.title'),
      message: i18n.t('general.save.done'),
    });
  });
};
</script>

<style lang="scss" scoped>
.useable-placeholders-container,
.useable-json-keys-container {
  display: flex;
  align-items: center;
  direction: row;
  color: $textcolor-light;
  font-size: 12px;
}

.useable-placeholders,
.useable-json-keys {
  display: flex;
  align-items: center;
  direction: row;
  gap: 10px;
}

.useable-placeholders-item,
.useable-json-keys-item {
  display: flex;
  align-items: center;
  direction: row;
}
</style>
